module.exports = __webpack_public_path__ + "static/media/truck.dc4b62ad.jpg";